import React from "react";

/**
 * Injects sticky style for one or more columns.
 * 
 * @param {number[] | number} columnIndexes - One or more 1-based column indexes to make sticky
 * @param {number[]} leftOffsets - Optional: Array of `left` offsets in px (should match columnIndexes length)
 */
const StickyColumn = ({ columnIndexes, leftOffsets = [] }) => {
  if (!columnIndexes || (Array.isArray(columnIndexes) && columnIndexes.length === 0)) {
    console.warn("StickyColumnStyle requires at least one column index.");
    return null;
  }

  const indexes = Array.isArray(columnIndexes) ? columnIndexes : [columnIndexes];

  const styles = indexes
    .map((colIndex, i) => {
      const left = leftOffsets[i] ?? 0;
      return `
        .rdt_TableCol:nth-child(${colIndex}) {
          position: sticky !important;
          left: ${left}px !important;
          background: white !important;
          z-index: 2 !important;
        }

        .rdt_TableCell:nth-child(${colIndex}) {
          position: sticky !important;
          left: ${left}px !important;
          background: white !important;
          z-index: 1 !important;
        }
      `;
    })
    .join("\n");

  return (
    <style>
      {`
        ${styles}
        .rdt_TableHeadRow {
          z-index: 3 !important;
        }
      `}
    </style>
  );
};

export default StickyColumn;
